import React from 'react';
import { Panel, PanelPlacement } from '../common/Panel/Panel';
import { DiceSelector } from '../DiceSelector/DiceSelector';
import { ResultModifier } from '../ResultModifier/ResultModifier';
import { RollSuggestions } from '../RollSuggestions/RollSuggestions';
import { DiceSkinSelector } from '../DiceStyleSelector/DiceStyleSelector';
import { Stack, StackDirection } from '../common/Stack';
import { useTutorialShowsDicePanelExtras } from '../../redux/tutorial/selectors';

import styles from './DicePanel.module.css';

type Props = {
  onDismiss: () => void;
  panelPlacement?: PanelPlacement;
};

export const DicePanel: React.FC<Props> = ({ panelPlacement, onDismiss }) => {
  const showExtras = useTutorialShowsDicePanelExtras();

  return (
    <Panel onDismiss={onDismiss} panelPlacement={panelPlacement} showOverlay={panelPlacement === 'bottom'}>
      <Stack direction={StackDirection.Vertical} gap={20} className={styles.container}>
        <DiceSelector />
        {showExtras && <RollSuggestions />}
        {showExtras && <ResultModifier />}
        {showExtras && <DiceSkinSelector />}
      </Stack>
    </Panel>
  );
};
